export default __webpack_public_path__ + "static/media/program-banner-el.af6588d9.jpg";